import {customElement} from "solid-element";
import {createEffect} from "solid-js";
// @ts-ignore
import icons from "bundle-text:./assets/*.svg";

customElement("builderall-icon", {code: ""}, (props, {element}) => {
    createEffect(() => {
        const svg = icons[props.code];
        if (!svg) return;

        (element.renderRoot as ShadowRoot).innerHTML = svg;

        Object.assign(
            (element.renderRoot.firstElementChild as HTMLElement).style,
            {
                fill: "var(--builderall-icon-color)",
                width: "var(--builderall-icon-size)",
                height: "var(--builderall-icon-size)",
            },
        );
    });
});